export const getLists = () => ({
    type: 'GET_LISTS',
});